<template>
  <div>
    <template v-if="loading">
      <div
        class="d-flex vertical-center justify-content-center align-items-center"
        style="height: 50vh; dislay: flex; margin-top: 100px"
      >
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <div class="video_setting" v-show="!loading">
        <div class="video_setting">
          <video
            autoplay
            controls
            controlsList="nodownload"
            id="myVideo"
            @play="getProgress"
            @loadeddata="onPaused"
            @pause="onPaused"
            ref="videoRef"
          >
            <source :src="VideoUrl" type="video/mp4" />
          </video>
        </div>
        <div class="position">
          <CButton
            color="info"
            size="lg"
            :disabled="disable"
            @click="nextRoute"
          >
            {{ `${disable ? progressTime : "Next"}` }}
          </CButton>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LoadingMDL from "@/components/loading/LoadingMDL";

export default {
  components: { LoadingMDL },
  name: "VAT01",
  props: {},
  data() {
    return {
      VideoUrl: "",
      disable: null,
      play: false,
      loading: true,
      showVideo: false,
      duration: null,
      progressTime: 0,
      language: "",
      time: null,
      navigation: null,
      condition: [],
      startTime: "",
      criteria_id: "",
      topic: {},
      //code: "605418cb883ae722ba1b0c5f",
      code: "",
      section:"",
      chapter: null,
    };
  },
  methods: {
    onPaused: function (val) {
      if (this.duration != 0 && val.target.currentTime == val.target.duration) {
        this.$refs.videoRef.play();
      }
      clearInterval(this.time);
    },
    getProgress: function (val) {
      if (val.target.duration != null) {
        if (this.duration == null) {
          this.duration = parseInt(val.target.duration);
        }
        if (this.disable) {
          this.time = setInterval(() => {
            this.duration = this.duration - 1;
            if (this.duration == 0) {
              this.disable = false;
              clearInterval(this.time);
            }
            const minute = this.duration / 60;
            const secon = (this.duration % 60) / 10;
            this.progressTime = `${Math.trunc(minute)}:${
              Number.isInteger(secon)
                ? `${secon}0`
                : secon.toString().replace(".", "")
            }`;
          }, 1000);
        }
      }
    },
    commitUserProgress: function () {
      this.loading = true;
      this.$store.dispatch("template/commitUserProgressChinese2", {
        code: this.code,
        contentId: this.criteria_id,
        answering: [],
        startTime: this.startTime,
        endTime: this.$helpers.getDateFormat(),
        topic: this.topic,
        chapter: this.chapter,
        condition: this.condition,
      });
    },
    nextRoute: function () {
      this.commitUserProgress();
    },
  },
  computed: {
    ...mapGetters({
      getTemplateAndProgress: "template/getTemplateAndProgress",
      getResponseStatus: "template/getResponseStatus",
      storeLanguage: "language/getLanguage",
    }),
  },
  watch: {
    getTemplateAndProgress: async function (value) {
      if (value.criteria.condition.criteriaType.length != 0) {
        this.condition.push({
          criteria: value.criteria.condition.criteriaType[0]._id,
          val: value.criteria.condition.criteriaType[0].val,
        });
      }
      this.criteria_id = value.criteria._id;
      this.chapter = value.chapter;
      this.topic = value.topicPosition;

      this.disable = value.disable;
      this.navigation = value.templateData.navigate.next.action;
      this.VideoUrl =
        "https://mdl.mfu.ac.th" + value.templateData.content.item[0].data;
      this.loading = false;
    },
    getResponseStatus: function (value) {
      if (value.status == 200) {
        if (this.navigation != "") {
          var str = this.navigation.split("-");
          let body = "/" + str[0] + "/" + str[1];
          this.$router.push(body);
        }
      }
    },
    storeLanguage: function (value) {
      this.language = value;
    },
  },
  created() {
    this.loading = true;
    this.currentRoute = this.$route.name + "-" + this.$route.params.id;
    this.courseData = this.$store.getters["necessary/getLerningCourse"]
    this.code = this.courseData._id;
    this.section = this.$store.getters['necessary/getUserCourseSection']
    console.log(this.section);
    console.log(this.code,this.section);
  },
  mounted() {
    this.language = this.$store.getters["language/getLanguage"];
    let payload = {
      templateCode: this.currentRoute,
      code: this.code,
      // section: "testing",
      section:this.section
    };
    this.$store.dispatch("template/fetchTemplateAndProgress", payload);
  },
  beforeDestroy() {},
};
</script>

<style scoped>
.position {
  display: flex;
  position: absolute;
  right: 8%;
  top: 10%;
}
video::-internal-media-controls-download-button {
  display: none;
}
.button_setting {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  padding: 0px 1px 0px 1px;
  background-color: #89abe6;
  width: 120px;
  height: 60px;
  color: white;
  border-radius: 7px !important;
  cursor: pointer;
}
.video_setting {
  background-color: black;
  display: flex;
  justify-content: center;
  align-items: center;
}

#myVideo {
  margin-top: 2.5%;
  right: 0;
  bottom: 0;
  width: 90%;
  height: 90%;
}
.video_setting {
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-info {
  width: 150px;
  height: 60px;
  font-size: 25px;
}

/* @media only screen and (max-width: 600px) {
  #myVideo {
    width: 100%;
    height: 250px !important;
  }
} */
@media only screen and (max-width: 600px) {
  #myVideo {
    width: 100%;
    height: 250px !important;
  }
  .video_setting {
    padding-top: 30%;
    padding-bottom: 20%;
  }
  .btn-info {
    width: auto;
    height: auto;
    font-size: 20px;
  }
  .position {
    top: 40%;
  }
}
@media only screen and (min-width: 667px) and (max-width: 812px) {
  .position {
    right: 8%;
    top: 8%;
  }
  .video_setting {
    padding-top: 3%;
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1025px) and (orientation: portrait){
  .position {
    right: 8%;
    top: 10%;
  }
  .video_setting {
    padding-top: 1%;
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1025px) and (min-height: 1365px) and (max-height: 1366px){
  .position {
    right: 8%;
    top: 8%;
  }
  .video_setting {
    padding-top: 1%;
  }
}
@media only screen and (min-width: 1026px) and (max-width: 1366px) {
  .position {
    right: 8%;
    top: 10%;
  }
}
</style>